import {
  type BookedFlightItineraryWithDepartureTime,
  type FiatPrice,
  Status,
  type TravelCredit,
} from "@b2bportal/air-booking-api";
import { useI18nContext } from "@hopper-b2b/i18n";
import { ItineraryCardNotification, NotificationSeverity } from "@tenant/ui";

interface FlightCardNotificationProps {
  itinerary: BookedFlightItineraryWithDepartureTime;
}

export const FlightCardNotification = ({
  itinerary,
}: FlightCardNotificationProps) => {
  const { t, formatFiatCurrency } = useI18nContext();
  const { status, travelCredit } = itinerary;
  const isCancel = status === Status.Canceled;

  const getCancelledNotificationLabel = (ftc?: TravelCredit) => {
    if (ftc) {
      const fiatAmount: Omit<FiatPrice, "currencySymbol"> = {
        value: ftc.credit.amount,
        currencyCode: ftc.credit.currency,
      };
      const formattedCredit = formatFiatCurrency(fiatAmount);

      return t(
        "core-flights.itinerary.card.notificationBanner.cancelledItineraryCredit",
        {
          interpolation: { escapeValue: false },
          formattedCredit,
        }
      );
    }
    return t(
      "core-flights.itinerary.card.notificationBanner.cancelledItineraryPeriod"
    );
  };

  if (isCancel) {
    const label = getCancelledNotificationLabel(travelCredit);

    return (
      <ItineraryCardNotification
        severity={NotificationSeverity.WARNING}
        label={label}
      />
    );
  }

  return null;
};
